export const HISTORICAL_SCENARIOS_ALADDIN_IDS = ['SUMMER03', 'JUL03_MTG', 'CREDIT07', 'C08_REL', 'RECESSION1', 'FEDTAP13', 'CHINA15R'];
export const UNIVARIATE_SCENARIOS_ALADDIN_IDS = ['MS_WORLD', 'MS_EURO', 'MS_EUYC_UP', 'MS_EUCPIUP', 'MS_EUCRDUP', 'MS_USD_DN', 'MSVIX_up',
	'MSOIL_dn', 'MSGOLD_dn', 'PN_CHF_UP', 'PN_STR_CHF', 'PN_SRE_DN', 'PN_GBP_UP', 'PN_STR_GBP', 'PN_UKRE_DN', 'MS_USCPIUP', 'MS_JPCPIUP'];
export const MARKET_DRIVEN_SCENARIOS_ALADDIN_IDS = ['OIL16_LOW', 'VOLREG', 'EUFRAG_PC', 'EUFRAG_EX', 'EUFRAG_MT', 'SARS_03', 'CVIRUS_GC',
	'CBN_PHASE2', 'CBN_ACCEL2', 'CBN_DIST2', 'VAL_CONT', 'VAL_DIFF', 'VAL_REV', 'FISC_NO', 'FISC_UNC', 'FISC_SUC', 'COVID_V', 'COVID_U', 'COVID_L'];
export const ALL_PAC_SCENARIOS_ALADDIN_IDS = [
	...HISTORICAL_SCENARIOS_ALADDIN_IDS,
	...UNIVARIATE_SCENARIOS_ALADDIN_IDS,
	...MARKET_DRIVEN_SCENARIOS_ALADDIN_IDS
];

export const ScenarioTesterDCR = {
	INTEREST_TITLE_DCR_VALUE: 'Interest Rates / Inflation',
	COMMODITIES_TITLE_DCR_VALUE: 'Commodities',
	EQUITIES_TITLE_DCR_VALUE: 'Equities',
	BONDS_TITLE_DCR_VALUE: 'Bonds / Credit Quality',
	PAST_TITLE_DCR_VALUE: 'Past Market Events',
	TITLE: 'Prepare for Market Moves',
	// Use for non-PAC data: ALL_SCENARIOS_VALUE, DEFAULT_SCENARIOS_VALUE
	ALL_SCENARIOS_KEY: 'ALL_SCENARIOS_VALUE',
	ALL_SCENARIOS_VALUE: 'AC_10Y_UP,AC_10Y_DN,AC_CPI_UP,AC_OIL_UP,AC_USHY_UP,AC_SPX_UP,AC_SPX_DN,AC_VIX_UP,C07_ABS,CRASH08,REC_ABS,FED13_ABS',
	DEFAULT_SCENARIOS_KEY: 'DEFAULT_SCENARIOS_VALUE',
	DEFAULT_SCENARIOS_VALUE: 'AC_10Y_UP,AC_CPI_UP,AC_SPX_DN,AC_USHY_UP,AC_VIX_UP,CRASH08',
	// Use for PAC data:
	HISTORICAL_ALL_SCENARIOS_KEY: 'HISTORICAL_ALL_SCENARIOS_VALUE',
	HISTORICAL_ALL_SCENARIOS_VALUE: HISTORICAL_SCENARIOS_ALADDIN_IDS.join(','),
	HISTORICAL_DEFAULT_SCENARIOS_KEY: 'HISTORICAL_DEFAULT_SCENARIOS_VALUE',
	HISTORICAL_DEFAULT_SCENARIOS_VALUE: HISTORICAL_SCENARIOS_ALADDIN_IDS.join(','),
	UNIVARIATE_ALL_SCENARIOS_KEY: 'UNIVARIATE_ALL_SCENARIOS_VALUE',
	UNIVARIATE_ALL_SCENARIOS_VALUE: UNIVARIATE_SCENARIOS_ALADDIN_IDS.join(','),
	UNIVARIATE_DEFAULT_SCENARIOS_KEY: 'UNIVARIATE_DEFAULT_SCENARIOS_VALUE',
	UNIVARIATE_DEFAULT_SCENARIOS_VALUE: UNIVARIATE_SCENARIOS_ALADDIN_IDS.join(','),
	MARKET_DRIVEN_ALL_SCENARIOS_KEY: 'MARKET_DRIVEN_DEFAULT_SCENARIOS_VALUE',
	MARKET_DRIVEN_ALL_SCENARIOS_VALUE: MARKET_DRIVEN_SCENARIOS_ALADDIN_IDS.join(','),
	MARKET_DRIVEN_DEFAULT_SCENARIOS_KEY: 'MARKET_DRIVEN_DEFAULT_SCENARIOS_VALUE',
	MARKET_DRIVEN_DEFAULT_SCENARIOS_VALUE: MARKET_DRIVEN_SCENARIOS_ALADDIN_IDS.join(','),
	PAST_SCENARIOS_KEY: 'PAST_SCENARIOS_VALUE',
	PAST_SCENARIOS_VALUE: 'C07_ABS,REC_ABS,CRASH08,FED13_ABS',
	// eslint-disable-next-line max-len
	CATEGORY_FEATURED_KEY: 'CATEGORY_FEATURED_VALUE',
	CATEGORY_FEATURED_VALUE: 'AC_OIL_UP,AC_VIX_UP,AC_USIG_UP,AC_SPX_DN,AC_10Y_UP,AC_CPI_UP',
	FEATURED_SCENARIO_LABEL: 'FEATURED!',
	CATEGORY_INTEREST_INFLATION_KEY: 'CATEGORY_INTEREST_INFLATION_VALUE',
	CATEGORY_INTEREST_INFLATION_VALUE: 'AC_10Y_UP,AC_10Y_DN,AC_2Y_DN,AC_2Y_UP,AC_CPI_UP,AC_CPI_DN',
	CATEGORY_COMMODITIES_KEY: 'CATEGORY_COMMODITIES_VALUE',
	CATEGORY_COMMODITIES_VALUE: 'AC_COMM_DN,AC_COMM_UP,AC_GOLD_DN,AC_GOLD_UP,AC_OIL_UP,AC_OIL_DN,AC_DXY_DN,AC_DXY_UP',
	CATEGORY_EQUITIES_KEY: 'CATEGORY_EQUITIES_VALUE',
	CATEGORY_EQUITIES_VALUE: 'AC_EMEQ_DN,AC_EMEQ_UP,AC_EUEQ_DN,AC_EUEQ_UP,AC_GLEQ_DN,AC_GLEQ_UP,AC_VIX_UP,AC_VIX_DN,AC_SPX_UP,AC_SPX_DN',
	CATEGORY_BONDS_CREDIT_KEY: 'CATEGORY_BONDS_CREDIT_VALUE',
	CATEGORY_BONDS_CREDIT_VALUE: 'AC_USHY_DN,AC_USHY_UP,AC_USIG_DN,AC_USIG_UP',
	CATEGORY_PAST_FEATURED_KEY: 'CATEGORY_PAST_FEATURED_VALUE',
	CATEGORY_PAST_FEATURED_VALUE: 'C07_ABS,CRASH08,REC_ABS,FED13_ABS',
	TWELVE_MONTH_TRAILING_YIELD_KEY: 'TWELVE_MONTH_TRAILING_YIELD_LABEL',
	TWELVE_MONTH_TRAILING_YIELD_LABEL: 'Trailing 12 months yield (%)',
	TWELVE_MONTH_TRAILING_YIELD_DESCRIPTION: 'TBC',
	TWELVE_MONTH_TRAILING_YIELD_DESCRIPTION_KEY: 'TWELVE_MONTH_TRAILING_YIELD_DESCRIPTION',
	CRBN_PHASE_LABEL: 'Phased Carbon Tax',
	CRBN_PHASE_DESCRIPTION: 'As climate change awareness increases, policymakers around the world steadily introduce new carbon taxes.',
	CRBN_ACCEL_LABEL: 'Accelerated Carbon Tax',
	CRBN_ACCEL_DESCRIPTION: 'Global policymakers respond to extreme weather events in a coordinated fashion, implementing carbon tax policies on an accelerated timeline.',
	CRBN_DIST_LABEL: 'Redistribution Carbon Tax',
	CRBN_DIST_DESCRIPTION: 'Lawmakers in developed nations introduce legislation to simultaneously fight climate change and economic inequality.',
	SARS_03_LABEL: '2003 SARS Outbreak',
	SARS_03_DESCRIPTION: 'A historical scenario capturing the APAC-driven sell-off from April 18-25, 2003, when China revealed there were many more SARS cases than first reported.',
	CVIRUS_GC_LABEL: 'Coronavirus Global Contagion',
	CVIRUS_GC_DESCRIPTION: `A hypothetical scenario in which the coronavirus spreads globally, with increasing numbers of infections and deaths beyond China.
	More cities are placed on lockdown in an attempt to contain the virus, transport systems are closed, and flights are grounded. Reduced economic activity impacts global growth.`,
	POL_DIV_LABEL: 'China Leads Fiscal Policy Push',
	POL_DIV_DESCRIPTION: `China Leads Fiscal Policy Push: Contrary to major developed economies that are currently faced with fiscal
	implementation challenges, China and Brazil deliver with favorable fiscal initiatives.`,
	POL_UNC_LABEL: 'ECB Expands the QE-Eligible Universe',
	POL_UNC_DESCRIPTION: `ECB Expands the QE-Eligible Universe: Political and legal constraints leave little room for aggressive fiscal action in near
	term in the US and in the EU. The ECB will surprise the market, pursuing new, untraditional accommodative tools to help the region break out of
	longstanding stagnation.`,
	POL_GLO_LABEL: 'Monetary and Fiscal Policy Coordination',
	POL_GLO_DESCRIPTION: `Monetary and Fiscal Policy Coordination: As monetary tools are close to being exhausted and fiscal policy alone is proven
	less effective, a new and unconventional coordination between monetary and fiscal helps boost growth. This scenario is inspired by the
	BII\'s August 2019 publication titled \'Dealing with the next downturn\'.`,
	CYBERCLDV2_LABEL: 'Attack on the Cloud',
	CYBERCLDV2_DESCRIPTION: 'Hackers take over the infrastructure of key cloud service providers, with repercussions across industries.',
	CYBERFINV2_LABEL: 'Financial Services Defenses Breached',
	CYBERFINV2_DESCRIPTION: 'The US financial system is hit by a series of cyber attacks, forcing a shutdown of operations.',
	CYBERUTLV2_LABEL: 'US Power Grid Targeted',
	CYBERUTLV2_DESCRIPTION: 'A cyber attack on the US power grid results in sustained power outages and economic damage.',
	GROWTH_US_LABEL: 'US Policy Mistake',
	GROWTH_US_DESCRIPTION: `Markets expect central banks to continue easing in order to ward off the downside risks of a contraction.
	However, central banks disappoint with less accommodative monetary policy than anticipated.`,
	GROWTH_T_LABEL: 'Trade Tensions Risk Recession',
	GROWTH_T_DESCRIPTION: `Trade tensions continue to weigh on margins and profitability, thereby hampering business confidence and capex.
	Further escalation between China and the US edges economies closer to recession.`,
	GROWTH_EXT_LABEL: 'Central Banks Extend the Cycle',
	GROWTH_EXT_DESCRIPTION: 'Central banks continue easing in an effort to prolong the current economic cycle, though heightened uncertainty results in increased market volatility.',
	USCHNTECH_LABEL: 'Jousting for Tech Dominance',
	USCHNTECH_DESCRIPTION: `Jousting for Tech Dominance: In the competition for dominance in advanced technology, the US bans all exports of
	semiconductors to China citing national security concerns.`,
	USEUAUTOS_LABEL: 'US Auto Tariffs on EU',
	USEUAUTOS_DESCRIPTION: `US Auto Tariffs on EU: In an effort to reduce the US trade deficit, the Trump administration imposes 25% tariffs on all
	autos and auto components imported from Europe.`,
	AC_10Y_DN_LABEL: '10-Yr US Treasury Rate Falls',
	AC_10Y_DN_DESCRIPTION:
		`Defined as a 100 basis point (1%) decrease in the US 10-Year Treasury Rate. Typically falling rates are associated with decreased expectations
		US economic growth, falling equity prices and deteriorating credit quality.`,
	AC_10Y_UP_LABEL: '10-Yr US Treasury Rate Rises',
	AC_10Y_UP_DESCRIPTION:
		`Defined as a 100 basis point (1%) increase in the US 10-Year Treasury Rate. Typically rising rates are associated with increased expectations
		for US economic growth, rising equity prices and an increase in issuer credit quality for the area.`,
	AC_2Y_DN_LABEL: '2-Yr US Treasury Rate Falls',
	AC_2Y_DN_DESCRIPTION:
		`Defined as a 100 (1%) basis point decline in the US 2 -Year Treasury Rate. Short-term rates are set by central bank policy and are used to as
		a tool to maintain price stability or promote economic growth.`,
	AC_2Y_UP_LABEL: '2-Yr US Treasury Rate Rises',
	AC_2Y_UP_DESCRIPTION:
		`Defined as a 100 (1%) basis point rise in the US 2 -Year Treasury Rate. Short-term rates are set by central bank policy
		and are used to as a tool to maintain price stability or promote economic growth.`,
	AC_COMM_DN_LABEL: 'Commodity Prices Fall',
	AC_COMM_DN_DESCRIPTION:
		'Defined as a 20% drop in the Dow Jones UBS Commodities Index. Commodity prices typically depend on supply and demand dynamics, economic growth and inflation expectations.',
	AC_COMM_UP_LABEL: 'Commodity Prices Rise',
	AC_COMM_UP_DESCRIPTION:
		'Defined as a 20% rise in the Dow Jones UBS Commodities Index. Commodity prices typically depend on supply and demand dynamics, economic growth and inflation expectations.',
	AC_CPI_DN_LABEL: 'Inflation Expectations Fall',
	AC_CPI_DN_DESCRIPTION:
		`Defined as a 200 basis point (2%) decline in the difference between 2-Yr nominal US Treasury yields and 2-Yr Inflation Protected US Treasury
		yields (TIPS). Periods of deflation are usually characterized by slowdowns in growth, falling bond yields and decreasing consumer prices.`,
	AC_CPI_UP_LABEL: 'Inflation Expectations Rise',
	AC_CPI_UP_DESCRIPTION:
		`Defined as a 200 basis point (2%) increase in the difference between 2-Yr nominal US Treasury yields and 2-Yr Inflation Protected US Treasury
		yields (TIPS). Periods of inflation are usually characterized by higher growth, rising bonds yields and of course, increasing consumer prices.`,
	AC_EMEQ_DN_LABEL: 'Emerging Market Stocks Fall',
	AC_EMEQ_DN_DESCRIPTION:
		`Defined as 25% decrease in the MSCI Emerging Markets Index. Emerging economies tend to depend on developed economies for growth and decrease in
		value when global growth prospects slowdown or underwelm.`,
	AC_EMEQ_UP_LABEL: 'Emerging Market Stocks Rise',
	AC_EMEQ_UP_DESCRIPTION:
		`Defined as 25% increase in the MSCI Emerging Markets Index. Emerging economies tend to depend on developed economies for
		growth and increase in value when global growth prospects increase.`,
	AC_EUEQ_DN_LABEL: 'European Stocks Fall',
	AC_EUEQ_DN_DESCRIPTION:
		`Defined as a 20% decrease in the MSCI Europe. The MSCI Europe is a equity index representing large and mid cap companies within Europe.
		Typically a decrease in equity prices index indicates decreased expectations for economic growth.`,
	AC_EUEQ_UP_LABEL: 'European Stocks Rise',
	AC_EUEQ_UP_DESCRIPTION:
		`Defined as a 20% increase in the MSCI Europe. The MSCI Europe is a equity index representing large and mid cap companies within Europe.
		Typically an increase in equity prices index indicates increased expectations for economic growth.`,
	AC_EUIG_DN_LABEL: 'European Investment Grade Credit Spreads Tighten',
	AC_EUIG_DN_DESCRIPTION:
		`Assumes European Investment Grade Credit spreads decrease by 1%. Typically this is associated with a strengthening of economic conditions
		for European companies due to increase growth expectations for the area.`,
	AC_EUIG_UP_LABEL: 'European Investment Grade Credit Spreads Widen',
	AC_EUIG_UP_DESCRIPTION:
		`Assumes European Investment Grade Credit spreads increase by 1%. Typically this is associated with deteriorating economic conditions
		for European companies and a slowdown in growth for the area.`,
	AC_GLEQ_DN_LABEL: 'Global Stocks Fall',
	AC_GLEQ_DN_DESCRIPTION: 'Defined as a 20% decrease in the MSCI World Index. Generally decreasing equity prices are reflective of a slow down in economic growth.',
	AC_GLEQ_UP_LABEL: 'Global Stocks Rise',
	AC_GLEQ_UP_DESCRIPTION: 'Defined as a 20% increase in the MSCI World Index. Generally rising equity prices are reflective of increasing economic growth.',
	AC_GOLD_DN_LABEL: 'Gold Price Falls',
	AC_GOLD_DN_DESCRIPTION: 'Defined as a 20% decrease in the spot price of gold. Generally gold prices tend to fall as volatility subsides and investor confidence decrease.',
	AC_GOLD_UP_LABEL: 'Gold Price Rises',
	AC_GOLD_UP_DESCRIPTION: 'Defined as a 20% increase in the spot price of gold. Generally gold prices tend to rise when volatility and investor uncertainty increase.',
	AC_OIL_DN_LABEL: 'Oil Price Falls',
	AC_OIL_DN_DESCRIPTION:
		`Defined as a 35% decrease in Crude Oil Prices. Oil prices are typically a function of supply and demand for the resource.
		A decrease in price could indicate a decrease in demand for the resource due to instances such as a slow down in growth or an
		increase in availability of the resource.`,
	AC_OIL_UP_LABEL: 'Oil Price Rises',
	AC_OIL_UP_DESCRIPTION:
		`Defined as 35% increase in Crude Oil Prices. Oil prices are typically a function of supply and demand for the resource.
		An increase in price could indicate either an increase in demand due to instances such as pickup in global growth or
		reduction in supply due to the lack of availability of the resource.`,
	AC_SPX_DN_LABEL: 'US Large Cap Stocks Fall',
	AC_SPX_DN_DESCRIPTION:
		`Defined as a 15% decrease in the S&P 500. The S&P 500 is a market cap weighted large cap equity index located
		in the United States. Generally decreasing equity prices are reflective of a slowdown in economic growth.`,
	AC_SPX_UP_LABEL: 'US Large Cap Stocks Rise',
	AC_SPX_UP_DESCRIPTION:
		`Defined as a 15% increase in the S&P 500. The S&P 500 is a market cap weighted large cap equity index
		located in the United States.  Generally rising equity prices are reflective of increasing economic growth.`,
	AC_USHY_DN_LABEL: 'High Yield Spreads Tighten',
	AC_USHY_DN_DESCRIPTION:
		`Defined as a 200 basis point (2%) decrease in spreads between a benchmark high yield bond index and a US treasury index.
		Typically when high yield spreads tighten it is function of an economic upturn or risk on environment as the underlying
		credit quality of the issuers increase.`,
	AC_USHY_UP_LABEL: 'High Yield Spreads Widen',
	AC_USHY_UP_DESCRIPTION:
		`Defined as a 200 basis point (2%) increase in spreads between a benchmark high yield bond index and a US Treasury index.
		Typically when high yield spreads widen it is function of an economic slowdown or risk-off environment as the underlying
		credit quality of the issuers decrease.`,
	AC_USIG_DN_LABEL: 'Investment Grade Credit Spreads Tighten',
	AC_USIG_DN_DESCRIPTION:
		`Defined as a 100 basis point (1%) decrease in the spread between a benchmark investment grade
		bond index and a US treasury index. Typically when investment grade spreads tighten it is function of
		 an economic upturn or risk on environment as the underlying credit quality of the issuers increase.`,
	AC_USIG_UP_LABEL: 'Investment Grade Credit Spreads Widen',
	AC_USIG_UP_DESCRIPTION:
		`Defined as a 100 basis point (1%) increase in the spread between a benchmark investment grade bond index and a US treasury index.
		Typically when investment grade spreads widen it is function of an economic slowdown or risk-off
		environment as the underlying credit quality of the issuers decrease.`,
	AC_VIX_DN_LABEL: 'Stock Market Volatility Falls',
	AC_VIX_DN_DESCRIPTION:
		`Defined as a 20% decrease in the CBOE (Chicago Board of  Options Exchange) VIX Index.
		The VIX typically serves as a gauge for volatility expectations in the market places.
		When it falls, investors are anticipating decreased uncertainty and volatility.`,
	AC_VIX_UP_LABEL: 'Stock Market Volatility Rises',
	AC_VIX_UP_DESCRIPTION:
		`Defined as 20% increase in the CBOE (Chicago Board of Options Exchange) VIX Index .
		The VIX typically serves as a gauge for volatility expectations in the market place.
		When it rises, investors are anticipating increased uncertainty and volatility.`,
	REC_ABS_LABEL: 'Recession (2007-2009)',
	REC_ABS_DESCRIPTION:
		`2008 Recession - Assumes repeat of the 2008 Recession (12/3/2007-03/09/2009).
		Starting date for the scenario is the official beginning of the latest recession in the US.
		The end date is the lowest point of the S&P 500 in the recent decade.`,
	C07_ABS_LABEL: 'Credit Crisis of 2007',
	C07_ABS_DESCRIPTION:
		`2007 Credit Crunch - Assumes repeat of 2007 Credit Crunch (07/01/2007-07/01/2008). Credit and liquidity crisis stemming
		from a severe slowdown in the US housing market causing significant widening of credit spreads and an increased implied volatility.`,
	CRASH08_LABEL: 'Crash of 2008',
	CRASH08_DESCRIPTION:
		`2008 Market Crash - Assumes repeat of 2008 Crash (09/12/2008-11/03/2008).
		Credit and liquidity crisis and equity market crash set off by Lehman brothers bankruptcy.
		Significant spread widening by massive deleveraging.`,
	FED13_ABS_LABEL: 'Taper Tantrum (2013)',
	FED13_ABS_DESCRIPTION: '2013 Fed Stimulus Tapering - Assumes repeat of the Fed Stimulus Tapering 2013 (5/21/2013-6/24/2013).',
	AC_DXY_DN_LABEL: 'US Dollar Falls',
	AC_DXY_DN_DESCRIPTION:
		`Defined as a 10% move in the DXY Index, which measures the value of the US Dollar against a basket of foreign currencies.
		A weakening dollar could result in higher inflation expectations and rising commodity prices.`,
	AC_DXY_UP_LABEL: 'US Dollar Rises',
	AC_DXY_UP_DESCRIPTION:
		`Defined as a 10% move in the DXY Index, which measures the value of the US Dollar against a basket of foreign currencies.
		A strong dollar could be a headwind in a weaker economy, with commodities and emerging markets showing more sensitivity to
		 moves in the US dollar.`,
	RESULTS_PORTFOLIOS_ASSET_CLASSES_HEADER: 'Portfolios & Asset Classes',

	// NILE

	HistoricalScenarios: {
		TITLE_KEY: 'HISTORICAL_SCENARIOS_TITLE',
		TITLE_VALUE: 'Historical Scenarios',
		SOURCE_KEY: 'HISTORICAL_SCENARIOS_SOURCE',
		SOURCE_VALUE: 'Source: BlackRock, Aladdin',
		SUMMER03_LABEL: 'Summer - 2003',
		SUMMER03_DESCRIPTION: 'Summer - 2003',
		JUL03_MTG_LABEL: 'MTG Widen - 2003',
		JUL03_MTG_DESCRIPTION: 'MTG Widen - 2003',
		CREDIT07_LABEL: 'Credit Crisis - 2007',
		CREDIT07_DESCRIPTION: 'Credit Crisis - 2007',
		C08_REL_LABEL: 'Market Crash - 2008',
		C08_REL_DESCRIPTION: 'Market Crash - 2008',
		RECESSION1_LABEL: 'Recession - 2008',
		RECESSION1_DESCRIPTION: 'Recession - 2008',
		FEDTAP13_LABEL: 'Fed Tapering - 2013',
		FEDTAP13_DESCRIPTION: 'Fed Tapering - 2013',
		CHINA15R_LABEL: 'Chinese Market Crash - 2015',
		CHINA15R_DESCRIPTION: 'Chinese Market Crash - 2015'
	},

	UnivariateScenarios: {
		TITLE_KEY: 'UNIVARIATE_SCENARIOS_TITLE',
		TITLE_VALUE: 'Univariate Scenarios',
		SOURCE_KEY: 'UNIVARIATE_SCENARIOS_SOURCE',
		SOURCE_VALUE: 'Source: BlackRock, Aladdin',
		MS_WORLD_LABEL: 'Stock Market Drop Global',
		MS_WORLD_DESCRIPTION: 'Stock Market Drop Global',
		MS_EURO_LABEL: 'Stock Market Drop Europe',
		MS_EURO_DESCRIPTION: 'Stock Market Drop Europe',
		MS_EUYC_UP_LABEL: 'Interest Rates Back-up Europe',
		MS_EUYC_UP_DESCRIPTION: 'Interest Rates Back-up Europe',
		MS_EUCPIUP_LABEL: 'Rising Inflation Europe',
		MS_EUCPIUP_DESCRIPTION: 'Rising Inflation Europe',
		MS_EUCRDUP_LABEL: 'Credit Spread Widening Europe',
		MS_EUCRDUP_DESCRIPTION: 'Credit Spread Widening Europe',
		MS_USD_DN_LABEL: 'Weak US Dollar',
		MS_USD_DN_DESCRIPTION: 'Weak US Dollar',
		MSVIX_up_LABEL: 'Equity Volatility Increase',
		MSVIX_up_DESCRIPTION: 'Equity Volatility Increase',
		MSOIL_dn_LABEL: 'Oil Down',
		MSOIL_dn_DESCRIPTION: 'Oil Down',
		MSGOLD_dn_LABEL: 'Gold Down',
		MSGOLD_dn_DESCRIPTION: 'Gold Down',
		PN_CHF_UP_LABEL: 'Interest Rates Back-Up Switzerland',
		PN_CHF_UP_DESCRIPTION: 'Interest Rates Back-Up Switzerland',
		PN_STR_CHF_LABEL: 'Strong CHF',
		PN_STR_CHF_DESCRIPTION: 'Strong CHF',
		PN_SRE_DN_LABEL: 'Depreciation in Swiss Real Estate',
		PN_SRE_DN_DESCRIPTION: 'Depreciation in Swiss Real Estate',
		PN_GBP_UP_LABEL: 'Interest Rates Back-Up UK',
		PN_GBP_UP_DESCRIPTION: 'Interest Rates Back-Up UK',
		PN_STR_GBP_LABEL: 'Strong GBP',
		PN_STR_GBP_DESCRIPTION: 'Strong GBP',
		PN_UKRE_DN_LABEL: 'Depreciation in UK Real Estate',
		PN_UKRE_DN_DESCRIPTION: 'Depreciation in UK Real Estate',
		MS_USCPIUP_LABEL: 'Rising Inflation US',
		MS_USCPIUP_DESCRIPTION: 'Rising Inflation US',
		MS_JPCPIUP_LABEL: 'Rising Inflation Japan',
		MS_JPCPIUP_DESCRIPTION: 'Rising Inflation Japan'
	},

	MarketDrivenScenarios: {
		TITLE_KEY: 'MARKET_DRIVEN_SCENARIOS_TITLE',
		TITLE_VALUE: 'Market Driven Scenarios',
		SOURCE_KEY: 'MARKET_DRIVEN_SCENARIOS_SOURCE',
		SOURCE_VALUE: 'Source: Based on BlackRock Market Driven Scenarios (MDS), developed by the Risk & Quantitative Analysis team (RQA).',
		VOLSPIKE_LABEL: 'Volatile Regimes - Transitory Spike in Vol',
		VOLSPIKE_DESCRIPTION: 'Volatile Regimes - Transitory Spike in Vol',
		OIL16_LOW_LABEL: 'Oil Fragility - A lot Lower For A Lot Longer',
		OIL16_LOW_DESCRIPTION: 'Oil Fragility - A lot Lower For A Lot Longer',
		VOLREG_LABEL: 'Volatile Regimes - Regime Change in Vol',
		VOLREG_DESCRIPTION: 'Volatile Regimes - Regime Change in Vol',
		EUFRAG_PC_LABEL: 'Europe Fragmentation - Meaningful Policy Change',
		EUFRAG_PC_DESCRIPTION: 'Europe Fragmentation - Meaningful Policy Change',
		EUFRAG_EX_LABEL: 'Europe Fragmentation - Italian Populism threatens the Eurozone',
		EUFRAG_EX_DESCRIPTION: 'Europe Fragmentation - Italian Populism threatens the Eurozone',
		EUFRAG_MT_LABEL: 'Europe Fragmentation - Eurozone Breakup',
		EUFRAG_MT_DESCRIPTION: 'Europe Fragmentation - Eurozone Breakup',
		SARS_03_LABEL: 'Coronavirus - 2003 SARS Outbreak',
		SARS_03_DESCRIPTION: 'Coronavirus - 2003 SARS Outbreak',
		CVIRUS_GC_LABEL: 'Coronavirus - Coronavirus Global Contagion',
		CVIRUS_GC_DESCRIPTION: 'Coronavirus - Coronavirus Global Contagion',
		COVID_V_LABEL: 'Coronavirus - Moderate Recovery',
		COVID_V_DESCRIPTION: 'Coronavirus - Moderate Recovery',
		COVID_U_LABEL: 'Coronavirus - Global Recession',
		COVID_U_DESCRIPTION: 'Coronavirus - Global Recession',
		COVID_L_LABEL: 'Coronavirus - Depression Fears',
		COVID_L_DESCRIPTION: 'Coronavirus - Depression Fears',
		CBN_PHASE2_LABEL: 'Carbon Tax Regimes - Phased Carbon Tax',
		CBN_PHASE2_DESCRIPTION: 'Carbon Tax Regimes - Phased Carbon Tax',
		CBN_ACCEL2_LABEL: 'Carbon Tax Regimes - Accelerated carbon tax',
		CBN_ACCEL2_DESCRIPTION: 'Carbon Tax Regimes - Accelerated carbon tax',
		CBN_DIST2_LABEL: 'Carbon Tax Regimes - Redistribution carbon tax',
		CBN_DIST2_DESCRIPTION: 'Carbon Tax Regimes - Redistribution carbon tax',
		VAL_CONT_LABEL: 'Value Sustainability - Continued Outperformance',
		VAL_CONT_DESCRIPTION: 'Value Sustainability - Continued Outperformance',
		VAL_DIFF_LABEL: 'Value Sustainability - European Underperformance',
		VAL_DIFF_DESCRIPTION: 'Value Sustainability - European Underperformance',
		VAL_REV_LABEL: 'Value Sustainability - Reversal',
		VAL_REV_DESCRIPTION: 'Value Sustainability - Reversal',
		FISC_NO_LABEL: 'Fiscal Policy Stance - Neutral',
		FISC_NO_DESCRIPTION: 'Fiscal Policy Stance - Neutral',
		FISC_UNC_LABEL: 'Fiscal Policy Stance - Ineffective Spending',
		FISC_UNC_DESCRIPTION: 'Fiscal Policy Stance - Ineffective Spending',
		FISC_SUC_LABEL: 'Fiscal Policy Stance - Credible Fiscal Policy',
		FISC_SUC_DESCRIPTION: 'Fiscal Policy Stance - Credible Fiscal Policy'
	}

};


